/* @flow */
import bisect from "binary-search";

function magnify<D, S>(
  dataset: Array<D>,
  sample: S,
  compare: (D, S) => number
): D {
  // Для поиска нужной точки в кеше мы используем бинарный поиск.
  const potentialIndex = bisect(dataset, sample, compare);

  // Если бинарный поиск не нашёл точный результат, он возвращает
  // индекс, где этот результат должен был лежать, только в виде от-
  // рицательного заначения.
  // Нам неточный результат тоже сгодится.
  const index = potentialIndex > 0 ? potentialIndex : -potentialIndex;

  return dataset[index - 1];
}

export default magnify;



// WEBPACK FOOTER //
// ./src/components/Chart/magnify.js